module.exports = __webpack_public_path__ + "static/media/wallet-connect.a43fae8d.svg";